import React from 'react';
import PropTypes from 'prop-types';
import {Label, FormGroup, Input, FormFeedback, FormText, InputGroup, InputGroupAddon} from 'reactstrap';
import { translate  } from 'react-i18next';

export  class TextField extends React.Component {

  static propTypes = {
    label: PropTypes.node,
    type: PropTypes.string,
    required: PropTypes.bool,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    error: PropTypes.bool,
    errorText: PropTypes.node,
    helperText: PropTypes.node,
    renderInput: PropTypes.func,
  };

  static defaultProps = {
    type: 'text'
  };

  constructor(props) {
    super(props);

    this.state = {
      isTouched: false,
    };
  }

  handleChange = (e) => {
    this.setState({
      isTouched: true
    });

    this.props.onChange && this.props.onChange(e);
  };

  handleBlur = (e) => {
    this.setState({
      isTouched: true
    });

    this.props.onBlur && this.props.onBlur(e);
  };

  renderInput(showError, error, errorText, value, props) {
    const input = <Input
      {...props}
      value={value || ''}
      onChange={this.handleChange}
      onBlur={this.handleBlur}
      invalid={showError && error}
    />;

    return this.props.renderInput ? this.props.renderInput(this.props, input) : input;
  }

  render() {
    let {
      label,
      error,
      errorText,
      helperText,
      children,
      required,
      value,
      t,
      append,
      i18nLoadedAt,
      renderInput,
      ...componentProps
    } = this.props;

    if (required) {
      if (!value) {
        error = true;
        errorText = t('This field is required');
      }
    }

    const showError = this.state.isTouched && error;

    return (
      <FormGroup>
        {label && <Label>{label}{required ? ' *' : ''}</Label>}
        {this.renderInput(showError, error, errorText, value, componentProps)}
        {
          showError && errorText ?
            <FormFeedback>{errorText}</FormFeedback> :
            helperText && <FormText>{helperText}</FormText>
        }
        {children}
      </FormGroup>
    );
  }
}

export default translate ()(TextField);


// WEBPACK FOOTER //
// ./src/App/Components/Form/TextField.js